import { render, staticRenderFns } from "./agency-service-lists.component.vue?vue&type=template&id=153b824a&"
import script from "./agency-service-lists.component?vue&type=script&lang=ts&"
export * from "./agency-service-lists.component?vue&type=script&lang=ts&"
import style0 from "./agency-service-lists.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports